var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGiftCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    "aria-hidden": "true",
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.24211V2.18947C20 0.978947 19.0211 0 17.8105 0H2.18947C0.978947 0 0 0.978947 0 2.18947V3.24211C0 3.34737 0.0894737 3.43684 0.194737 3.43684H19.8053C19.9105 3.43684 20 3.34737 20 3.24211Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.88421V11.5632C0 12.7737 0.978947 13.7526 2.18947 13.7526H17.8158C19.0263 13.7526 20.0053 12.7737 20.0053 11.5632V4.88421C20.0053 4.77895 19.9158 4.68948 19.8105 4.68948H0.194737C0.0894737 4.68948 0 4.77895 0 4.88421ZM5 10C5 10.3474 4.72105 10.6263 4.37368 10.6263H3.74737C3.4 10.6263 3.12105 10.3474 3.12105 10V9.37369C3.12105 9.02632 3.4 8.74737 3.74737 8.74737H4.37368C4.72105 8.74737 5 9.02632 5 9.37369V10Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/gift-card.d30afd8b7e4a54e3b45209f2a3c53b6d.svg";
export { ForwardRef as ReactComponent };